import { useEffect } from 'react';

type AdVideoGtmProps = {
  variant?: 'mobile' | 'desktop';
};

/**
 * Container vazio para o anúncio de vídeo in-content servido pelo GTM.
 *
 * Substitui os antigos componentes Truvid/Membrana, que carregavam o script de
 * terceiros diretamente no React. Agora o React apenas renderiza o contêiner
 * posicionado (`data-ad`) e sinaliza `ad_container_ready` no dataLayer; o GTM
 * decide (por categoria, via dataLayer) qual player de vídeo injetar aqui.
 */
export default function AdVideoGtm({ variant = 'desktop' }: AdVideoGtmProps) {
  useEffect(() => {
    const { adContainerReadyFired, dataLayer } = (window as any) || {};
    if (!adContainerReadyFired && dataLayer) {
      dataLayer.push({ event: 'ad_container_ready' });
      (window as any).adContainerReadyFired = true;
    }
  }, []);

  return <div id={`div-video-ad-${variant}`} className="videoAdPos" data-ad="true" />;
}
